/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Cash Cost Percentile
 * @export
 * @interface CashCostPercentile
 */
export interface CashCostPercentile {
    /**
     * 
     * @type {number}
     * @memberof CashCostPercentile
     */
    nightlyCashCostUsd: number;
    /**
     * Nightly cash cost converted to the user's preferred currency
     * @type {number}
     * @memberof CashCostPercentile
     */
    nightlyCashCostLocalized?: number;
    /**
     * 
     * @type {number}
     * @memberof CashCostPercentile
     */
    probability?: number;
    /**
     * 
     * @type {number}
     * @memberof CashCostPercentile
     */
    percentile: number;
}

/**
 * Check if a given object implements the CashCostPercentile interface.
 */
export function instanceOfCashCostPercentile(value: object): value is CashCostPercentile {
    if (!('nightlyCashCostUsd' in value) || value['nightlyCashCostUsd'] === undefined) return false;
    if (!('percentile' in value) || value['percentile'] === undefined) return false;
    return true;
}

export function CashCostPercentileFromJSON(json: any): CashCostPercentile {
    return CashCostPercentileFromJSONTyped(json, false);
}

export function CashCostPercentileFromJSONTyped(json: any, ignoreDiscriminator: boolean): CashCostPercentile {
    if (json == null) {
        return json;
    }
    return {
        
        'nightlyCashCostUsd': json['nightly_cash_cost_usd'],
        'nightlyCashCostLocalized': json['nightly_cash_cost_localized'] == null ? undefined : json['nightly_cash_cost_localized'],
        'probability': json['probability'] == null ? undefined : json['probability'],
        'percentile': json['percentile'],
    };
}

export function CashCostPercentileToJSON(json: any): CashCostPercentile {
    return CashCostPercentileToJSONTyped(json, false);
}

export function CashCostPercentileToJSONTyped(value?: CashCostPercentile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nightly_cash_cost_usd': value['nightlyCashCostUsd'],
        'nightly_cash_cost_localized': value['nightlyCashCostLocalized'],
        'probability': value['probability'],
        'percentile': value['percentile'],
    };
}

